<template>
<footer id="footer" class="footer bg-purple">
    <div class="container">
        <div class="columns is-multiline">
            <div class="column col-1 ts-logo">
                <img alt="Thinkstep logo" class="is-block" src="@/assets/thinkstep-anz_logo_2.png" />
            </div>
            <div class="column col-2 social-medias">
                <a v-if="site_data.siteconfig.footer.socials.linkedin" :href="site_data.siteconfig.footer.socials.linkedin" target="_blank">
                    <img alt="Linkedin logo" class="is-block" src="@/assets/linkedIn.png" />
                </a>
                <a v-if="site_data.siteconfig.footer.socials.youtube" :href="site_data.siteconfig.footer.socials.youtube" target="_blank">
                    <img alt="Youtube logo" class="is-block" src="@/assets/youtube.png" />
                </a>
            </div>
        </div>
        <div class="columns is-multiline contact-info">
            <div :class="['column', 'col-' + (i + 1)]" v-for="item, i in site_data.siteconfig.footer.columns">
                <div class="content" v-html="item"></div>
            </div>
        </div>
        <div class="columns is-multiline info">
            <div class="column col-1" v-html="site_data.siteconfig.footer.slogan"></div>
            <div class="column col-2">
                <img alt="B Corp logo" class="is-block" src="@/assets/B_corp_logo_white.png" />
                <img alt="SBTi logo" class="is-block has-padding" src="@/assets/SBTi_logo_white.png" />
                <img alt="CLC logo" class="is-block has-padding" src="@/assets/CLC_Logo_white_text.png" />
            </div>
        </div>
        <div class="columns is-multiline links">
            <div class="column col-1 link" v-html="site_data.siteconfig.footer.links"></div>
            <div class="column col-2 copyright">
                ©thinkstep-anz 2023
            </div>
        </div>
    </div>
</footer>   
</template>

<script>
export default {
    name: 'Footer',
    props: [
        'site_data'
    ],
    data: function() {
        return {

        };
    },
    components: {},
    watch: {

    },
    computed: {
        year() {
            let d = new Date();

            return d.getFullYear();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Footer.vue